"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var styles_1 = __importDefault(require("./styles"));
var Item = function (_a) {
    var isHidden = _a.isHidden, children = _a.children, onClick = _a.onClick, isSelected = _a.isSelected;
    if (isHidden)
        return null;
    return (react_1.default.createElement(styles_1.default, { className: "option " + (isSelected ? 'selected' : ''), onClick: onClick },
        react_1.default.createElement("span", { className: "label" }, children),
        react_1.default.createElement(Icon_1.default, { isHidden: !isSelected, icon: "check" })));
};
exports.default = Item;
//# sourceMappingURL=index.js.map